import React from 'react'
import { string, number, oneOfType, bool } from 'prop-types'
import { formatValor } from '../../../utils/formatter/formatter'
import { PLANOS, METODO_PAGAMENTO_CARTAO, PLANO_ANUAL } from '../../../constants'

const ValorTotal = ( {
  formaPagamento,
  nroParcelas,
  tipoPlano,
  valorDescontoCupom,
  valorDescontoCombo,
  valorPlanoTotal,
  precoFreteEntrega,
} ) => {
  const dadosPlano = PLANOS.find( plano => tipoPlano === plano.visualizacao )
  const freteTotal = precoFreteEntrega * dadosPlano.parcelas
  const valorTotalSemDesconto = valorPlanoTotal + freteTotal
  const valorTotal = valorTotalSemDesconto - valorDescontoCupom - valorDescontoCombo

  if (
    formaPagamento === METODO_PAGAMENTO_CARTAO.inicial &&
    dadosPlano.visualizacao === PLANO_ANUAL.visualizacao
  ) {
    const valorParcela = valorTotal / nroParcelas
    return (
      <div className="titulo__total">
        <h2>
          {`Total: ${nroParcelas}x ${formatValor( {
            'valor': valorParcela
          } )}`}
        </h2>

        <small>{`(${formatValor( { 'valor': valorTotal } )})`}</small>
      </div>
    )
  }

  return (
    <div className="titulo__total">
      <h2>{`Total: ${formatValor( { 'valor': valorTotal } )}`}</h2>
    </div>
  )
}

ValorTotal.defaultProps = {
  'hasEnvioUnico': false
}

ValorTotal.propTypes = {
  'formaPagamento': string.isRequired,
  'hasEnvioUnico': bool,
  'nroParcelas': oneOfType( [ number, null ] ).isRequired,
  'precoFreteEntrega': number.isRequired,
  'tipoPlano': string.isRequired,
  'valorDescontoCombo': number.isRequired,
  'valorDescontoCupom': number.isRequired,
  'valorPlanoTotal': number.isRequired,
}

export default ValorTotal
